import axios from 'components/Axios';
import { CreateProfile, CurrentProfile, hashtag, mentionList, Profile } from '../APIEndPoint';

const UpdateProfile = (payload, userId, type) => {
  const promise = axios.put(
    `${type === 'createProfile' ? CreateProfile : Profile}/${userId}`,
    payload
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetProfileById = (payload) => {
  const promise = axios.get(`${Profile}/${payload}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetCurrentProfile = () => {
  const getUsername = window.location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim();
  const promise = axios.get(`${CurrentProfile}/${currentUsername}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetUsernameMention = (usernameValue, page, size) => {
  const promise = axios.get(`${mentionList}?username=${usernameValue}&page=${page || 0}&size=${size || 50}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetHashtag = () => {
  const promise = axios.get(hashtag);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export { UpdateProfile, GetProfileById, GetCurrentProfile, GetUsernameMention, GetHashtag };
